export type ConsentReplayEditorSelectionHint = {
  documentId: string;
  pmFrom?: number;
  pmTo?: number;
  plainTextStart?: number;
  plainTextEnd?: number;
};

export function resolveConsentReplaySelection(params: {
  replayPassage: string;
  replayEditorSelectionHint?: ConsentReplayEditorSelectionHint;
  chipPassage: string;
  chipHint?: ConsentReplayEditorSelectionHint;
}): { passage: string; hint?: ConsentReplayEditorSelectionHint } {
  const replayPassage = String(params.replayPassage ?? "").trim();
  const chipPassage = String(params.chipPassage ?? "").trim();
  const passage = replayPassage || chipPassage;
  const hint = params.replayEditorSelectionHint ?? (replayPassage ? undefined : params.chipHint);
  return {
    passage,
    ...(hint ? { hint } : {}),
  };
}
